import PropTypes from 'prop-types'
import { useContext } from 'react'
import ModalSidebarContext from './ModalSidebarContext'

const propTypes = {
  /**
   * Panel id, for multi-panel modals step key should match one of the steps provided in the ModalSidebar
   */
  stepKey: PropTypes.string,
  /**
   * Modal panel content
   */
  children: PropTypes.node,
}

/**
 * For multi-panel step modals, decides when to render content or not based on the stepKey
 */
function ModalPanelSwitch(props) {
  const { children = null, stepKey = null } = props ?? {}

  const { currentStepKey } = useContext(ModalSidebarContext)

  // do not render content if this panel is not the one for this step
  if (stepKey && stepKey !== currentStepKey) {
    return null
  }

  return children
}

ModalPanelSwitch.propTypes = propTypes

export default ModalPanelSwitch
